import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';
import { sharedCoverLetterClientDocumentVariable } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

export const sharedClientDocumentVariableWithLocalStorage = (
  doc: CoverLetterDocumentType
): void => {
  sharedCoverLetterClientDocumentVariable(doc);
  global?.window?.localStorage?.setItem(
    'vita-cover-letter',
    JSON.stringify({ ...doc, token: '' })
  );
};
